import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

interface SubmittedContext {
  readonly didSubmit: boolean;
  readonly setSubmit: (flag: boolean) => void;
}

interface Props {
  readonly children: ReactNode;
}

const SubmittedCtx = createContext<SubmittedContext>({
  didSubmit: false,
  setSubmit: () => {
    throw new Error('Missing SubmittedProvider upwards in the tree.');
  },
});
SubmittedCtx.displayName = 'SubmittedState';

export function SubmittedProvider({ children }: Props) {
  const [didSubmit, setSubmit] = useState(false);

  const value = useMemo(
    () => ({ didSubmit, setSubmit }),
    [didSubmit, setSubmit],
  );

  return (
    <SubmittedCtx.Provider value={value}>{children}</SubmittedCtx.Provider>
  );
}

export const useSubmitted = () => {
  return useContext(SubmittedCtx);
};

export default SubmittedProvider;
